module.exports = __webpack_public_path__ + "img/menu_gzbt_c.d7c6c47e.png";